import { render, staticRenderFns } from "./PricerConfigTab.vue?vue&type=template&id=14eb3ed9&scoped=true&"
import script from "./PricerConfigTab.vue?vue&type=script&lang=js&"
export * from "./PricerConfigTab.vue?vue&type=script&lang=js&"
import style0 from "./PricerConfigTab.vue?vue&type=style&index=0&id=14eb3ed9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14eb3ed9",
  null
  
)

export default component.exports